import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';

import { CalculatorComponent } from './calculator-component/calculator.component';
import { NgxMaskModule } from 'ngx-mask';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonDirectivesModule } from '../common-directives/common-directives.module';
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";

@NgModule({
  declarations: [
    CalculatorComponent,
  ],
  exports: [
    CalculatorComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    NgxMaskModule,
    MatCheckboxModule,
    CommonDirectivesModule,
    MatDialogModule,
    MatButtonModule,
  ],
})
export class CalculatorModule { }
